import { ReactNode } from "react";
import { CreateAdModal } from "@/app/components/create-ad-modal";
import { MenuDrawer } from "@/app/components/menu-drawer";
import { useAccountNavEnabled } from "@/app/context/account-nav-context";
import type { Ad } from "@/app/components/ad-card";

interface PageLayoutProps {
  children: ReactNode;
  isModalOpen: boolean;
  onCloseModal: () => void;
  onSubmitAd: (newAd: Omit<Ad, "id" | "createdAt">) => void;
  isMenuOpen: boolean;
  onCloseMenu: () => void;
  isLoggedIn?: boolean;
  userName?: string;
  userEmail?: string;
  userInitials?: string;
  userProfileImageUrl?: string;
  onLoginClick?: () => void;
  onLogout?: () => void;
  onNavigateToNotifications?: () => void;
  onNavigateToAddresses?: () => void;
  onNavigateToMyAds?: () => void;
  onNavigateToChat?: () => void;
  onNavigateToProfile?: () => void;
  onNavigateToSettings?: () => void;
  onNavigateToHelp?: () => void;
  onNavigateToReceivedOffers?: () => void;
  onNavigateToSentOffers?: () => void;
  onNavigateToSales?: () => void;
  onNavigateToPurchases?: () => void;
  onNavigateToWallet?: () => void;
}

export function PageLayout({
  children,
  isModalOpen,
  onCloseModal,
  onSubmitAd,
  isMenuOpen,
  onCloseMenu,
  isLoggedIn,
  userName,
  userEmail,
  userInitials,
  userProfileImageUrl,
  onLoginClick,
  onLogout,
  onNavigateToNotifications,
  onNavigateToAddresses,
  onNavigateToMyAds,
  onNavigateToChat,
  onNavigateToProfile,
  onNavigateToSettings,
  onNavigateToHelp,
  onNavigateToReceivedOffers,
  onNavigateToSentOffers,
  onNavigateToSales,
  onNavigateToPurchases,
  onNavigateToWallet,
}: PageLayoutProps) {
  const accountNav = useAccountNavEnabled();

  return (
    <>
      {children}
      
      <CreateAdModal
        isOpen={isModalOpen}
        onClose={onCloseModal}
        onSubmit={onSubmitAd}
      />

      {/* Hamburger menu: only when profile-complete hub (same as cart/favorites chrome) */}
      {accountNav && (
        <MenuDrawer 
          isOpen={isMenuOpen}
          onClose={onCloseMenu}
          isLoggedIn={isLoggedIn}
          userName={userName}
          userEmail={userEmail}
          userInitials={userInitials}
          userProfileImageUrl={userProfileImageUrl}
          onLoginClick={onLoginClick}
          onLogout={onLogout}
          onNavigateToNotifications={onNavigateToNotifications}
          onNavigateToAddresses={onNavigateToAddresses}
          onNavigateToMyAds={onNavigateToMyAds}
          onNavigateToChat={onNavigateToChat}
          onNavigateToProfile={onNavigateToProfile}
          onNavigateToSettings={onNavigateToSettings}
          onNavigateToHelp={onNavigateToHelp}
          onNavigateToReceivedOffers={onNavigateToReceivedOffers}
          onNavigateToSentOffers={onNavigateToSentOffers}
          onNavigateToSales={onNavigateToSales}
          onNavigateToPurchases={onNavigateToPurchases}
          onNavigateToWallet={onNavigateToWallet}
        />
      )}
    </>
  );
}